import { TOptions } from 'i18next';

export type TFunc = (arg0: string, arg1?: TOptions) => string;
